export default __webpack_public_path__ + "static/media/section1-bg-left.599ace73.png";